import { render, staticRenderFns } from "./configPromocionesFile.vue?vue&type=template&id=901e6fce&scoped=true"
import script from "./configPromocionesFile.vue?vue&type=script&lang=js"
export * from "./configPromocionesFile.vue?vue&type=script&lang=js"
import style0 from "./configPromocionesFile.vue?vue&type=style&index=0&id=901e6fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901e6fce",
  null
  
)

export default component.exports